<script setup lang="ts">
const isLoading = ref(false);
const { closeModal } = useLayoutStore();
const { getValidationModule } = useModulesValidation();

function handleAction() {
  const { $containment } = useNuxtApp();

  $containment.updateConfig({
    global: getValidationModule('global'),
  });

  isLoading.value = true;
  closeModal();

  setTimeout(() => {
    navigateTo(localeLink('/'));
  }, 1000);
}

const SECONDS_TO_REDIRECT = 5;
const countdownInterval = ref<number | null>(null);

const secondsToRedirect = ref(SECONDS_TO_REDIRECT);

const redirectIsStarted = computed(() => {
  return secondsToRedirect.value <= 0;
});

function startCountdown() {
  if (countdownInterval.value) {
    clearInterval(countdownInterval.value);
  }

  countdownInterval.value = setInterval(() => {
    if (secondsToRedirect.value > 0) {
      secondsToRedirect.value -= 1;
    } else {
      if (countdownInterval.value !== null) {
        clearInterval(countdownInterval.value);

        handleAction();
      }
      countdownInterval.value = null;
    }
  }, 1000) as unknown as number;
}

onMounted(() => {
  startCountdown();
});

onUnmounted(() => {
  if (countdownInterval.value) {
    clearInterval(countdownInterval.value);
  }
});
</script>

<template>
  <div :class="$style.boxContainer">
    <BaseLoading
      class="!bg-bg-primary !absolute"
      :icon-loader="true"
      :show="isLoading"
    />

    <img
      alt="Email icon"
      aria-hidden="true"
      :class="$style.modalIcon"
      :src="getAssetsUrlForCDN('/assets/images/svg/empty.svg')"
    />

    <p :class="$style.title">
      {{ $t('verification.empty.title') }}
    </p>

    <p
      :class="$style.description"
      v-html="$t('verification.empty.desc')"
    />

    <div :class="$style.timerSeconds"> </div>

    <button
      :class="[$style.submitBtn, 'btn-primary']"
      :disabled="redirectIsStarted"
      @click="handleAction()"
    >
      {{ $t('verification.empty.continue') }}

      <span :class="$style.timerSeconds">
        {{ redirectIsStarted ? '0s' : `${secondsToRedirect}s` }}
      </span>

      <NuxtIcon
        v-if="!redirectIsStarted"
        name="arrows/angle_right"
      />

      <span v-else>
        <NuxtIcon
          :class="[$style.loadingIcon, 'rotate-animation']"
          filled
          name="loading"
        />
      </span>
    </button>
  </div>
</template>

<style module lang="scss">
.boxContainer {
  @apply p-3 md:p-6 flex flex-col justify-center flex-1 text-texts text-center;

  .modalIcon {
    @apply w-28 h-28 mx-auto mb-5;
  }

  .title {
    @apply font-bold mb-3;
  }

  .description {
    @apply mb-1 max-w-80 inline-block mx-auto text-sm text-texts/80;

    strong {
      @apply text-primary/80;
    }
  }

  .submitBtn {
    @apply mx-auto rounded-md gap-1.5 flex items-center font-bold uppercase py-2.5 focus:outline-none focus:ring-4 mt-6;

    .timerSeconds {
      -webkit-font-variant-numeric: tabular-nums;
      -moz-font-variant-numeric: tabular-nums;
      font-variant-numeric: tabular-nums;
      letter-spacing: -0.02em;
    }

    .loadingIcon {
      @apply text-lg flex items-center justify-center;
    }
  }
}
</style>
